/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Activity_Sync_CompleteInputs */



/**
* | output |
* | --- |
* | "{name}: sync complete" |
*
* @param {Activity_Sync_CompleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_sync_complete = /** @type {((inputs: Activity_Sync_CompleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Sync_CompleteInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name}: Synchronisierung abgeschlossen`)
	return /** @type {LocalizedString} */ (`${i?.name}: sync complete`)
});